import { IonRouterLink } from '@ionic/react';
import classNames from 'classnames';
import { useGetBusinessQuery } from '../api/BusinessApi';
import { getBusinessImages } from '../util/getBusinessImages';
import { ProfileImage } from './ProfileImage';
import { SkeletonLoader } from './SkeletonLoader';
import GenericBusinessIcon from '../assets/buildingIcon.png';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './BusinessCheckInBanner.module.css';

export interface BusinessCheckInBannerProps {
	businessId: string;
}

export function BusinessCheckInBanner({ businessId }: BusinessCheckInBannerProps) {
	const { data: business, isLoading } = useGetBusinessQuery(businessId);
	const { logo = '' } = business ? getBusinessImages(business) : {};
	return (
		<div className={classNames(styles.BusinessCheckInBanner, isLoading ? styles.bannerLoading : '')}>
			<SkeletonLoader>
				{!isLoading && business ? (
					<>
						<div
							className={styles.businessLogoWrapper}
							style={{ backgroundColor: business.logoBackgroundColor ?? 'transparent' }}
						>
							<IonRouterLink routerLink={`/main/bus/show/${business._id}`}>
								<ProfileImage
									url={logo}
									size="medium"
									shape="square"
									contain
									border
									fallback={GenericBusinessIcon}
									alt={`Logo for ${business.name}`}
								/>
							</IonRouterLink>
						</div>
						<div className={styles.checkinTitle}>
							Checked in at{' '}
							<IonRouterLink routerLink={`/main/bus/show/${business._id}`}>{business.name}</IonRouterLink>
						</div>
					</>
				) : null}
			</SkeletonLoader>
		</div>
	);
}
